import React, { useState, useEffect } from 'react';
import { images } from '../../components/shared/assets';
import { initializeAllFeatures } from '../../utils/interactiveFeatures';
import SmartNavigation from '../../components/Navigation/SmartNavigation';
import Footer from '../../components/Footer/Footer';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';

// Film Collection Components
import FilmHero from '../../components/FilmCollection/FilmHero/FilmHero';
import FilmBackgroundSection from '../../components/FilmCollection/FilmBackgroundSection/FilmBackgroundSection';
import FilmIntro from '../../components/FilmCollection/FilmIntro/FilmIntro';
import FilmFilterBar from '../../components/FilmCollection/FilmFilterBar/FilmFilterBar';
import FilmGrid from '../../components/FilmCollection/FilmGrid/FilmGrid';
import FilmPagination from '../../components/FilmCollection/FilmPagination/FilmPagination';
import FilmCTA from '../../components/FilmCollection/FilmCTA/FilmCTA';
import { filmCards } from '../../components/FilmCollection/filmData';

import './FilmCollectionPage.css';

const FilmCollectionPage: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [destinationFilter, setDestinationFilter] = useState<string | null>(null);
  const [typeFilter, setTypeFilter] = useState<string | null>(null);

  const itemsPerPage = 10;
  const totalPages = Math.ceil(filmCards.length / itemsPerPage);

  // Filter films based on selected filters
  const filteredFilms = filmCards.filter(film => {
    if (destinationFilter && !film.location.toLowerCase().includes(destinationFilter.toLowerCase())) {
      return false;
    }
    // Add type filtering logic when implemented
    return true;
  });


  // Initialize interactive features and reset scroll position
  useEffect(() => {
    const cleanup = initializeAllFeatures();
    window.scrollTo(0, 0);
    return cleanup;
  }, []);

  return (
    <div className="film-collection-page">
      {/* Navigation */}
      <SmartNavigation 
        defaultVariant="transparent"
        scrolledVariant="light"
        autoSwitchOnScroll={true}
      />

      {/* Hero Section */}
      <FilmHero />

      {/* Background Video Section */}
      <FilmBackgroundSection videoSrc={images.filmRectangle1464} />

      {/* Film Collection Content */}
      <div className="film-collection-content">
        <FilmIntro />

        <FilmFilterBar 
          onDestinationChange={setDestinationFilter}
          onTypeChange={setTypeFilter}
        />

        <FilmGrid 
          films={filteredFilms}
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
        />

        <FilmPagination 
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      </div>

      {/* Spacer between pagination and background */}
      <div className="film-spacer"></div>

      {/* Second Background Image */}
      <FilmBackgroundSection 
        imageSrc={images.filmRectangle1465}
        className="film-background--waterfall"
      />

      {/* CTA Section */}
      <FilmCTA />

      {/* Instagram Section */}
      <InstagramSection />

      {/* Footer */}
      <Footer variant="default" />
    </div>
  );
};

export default FilmCollectionPage;